/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestViewsRouteImport } from './routes/test-views'
import { Route as AddonsRouteImport } from './routes/addons'
import { Route as FilesRouteRouteImport } from './routes/files/route'
import { Route as ExpensesRouteRouteImport } from './routes/expenses/route'
import { Route as DonationsRouteRouteImport } from './routes/donations/route'
import { Route as CampaignsRouteRouteImport } from './routes/campaigns/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FilesIndexRouteImport } from './routes/files/index'
import { Route as ExpensesIndexRouteImport } from './routes/expenses/index'
import { Route as DonationsIndexRouteImport } from './routes/donations/index'
import { Route as ContactsIndexRouteImport } from './routes/contacts/index'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as SettingsLayoutRouteImport } from './routes/settings/_layout'
import { Route as DonationsCategoriesRouteImport } from './routes/donations/categories'
import { Route as ContactsTasksRouteImport } from './routes/contacts/tasks'
import { Route as ContactsTaskTypesRouteImport } from './routes/contacts/task-types'
import { Route as ContactsFixAndMergeRouteImport } from './routes/contacts/fix-and-merge'
import { Route as ContactsContactIdRouteRouteImport } from './routes/contacts/$contactId_/route'
import { Route as SettingsLayoutIndexRouteImport } from './routes/settings/_layout.index'
import { Route as EmailsTemplatesIndexRouteImport } from './routes/emails/templates/index'
import { Route as EmailsScheduledIndexRouteImport } from './routes/emails/scheduled/index'
import { Route as EmailsDraftsIndexRouteImport } from './routes/emails/drafts/index'
import { Route as EmailsDesignsIndexRouteImport } from './routes/emails/designs/index'
import { Route as EmailssentIndexRouteImport } from './routes/emails/(sent)/index'
import { Route as DonationsDonationIdIndexRouteImport } from './routes/donations/$donationId/index'
import { Route as ContactsGroupsIndexRouteImport } from './routes/contacts/groups/index'
import { Route as ContactsContactIdIndexRouteImport } from './routes/contacts/$contactId_/index'
import { Route as SettingsLayoutEmailsRouteImport } from './routes/settings/_layout.emails'
import { Route as SettingsLayoutBillingRouteImport } from './routes/settings/_layout.billing'
import { Route as EmailsTemplatesTemplateIdRouteImport } from './routes/emails/templates/$templateId'
import { Route as EmailsScheduledScheduledIdRouteImport } from './routes/emails/scheduled/$scheduledId'
import { Route as EmailsDesignsDesignIdRouteImport } from './routes/emails/designs/$designId'
import { Route as ContactsGroupsGroupIdRouteImport } from './routes/contacts/groups/$groupId'
import { Route as ContactsContactIdFilesRouteImport } from './routes/contacts/$contactId_/files'
import { Route as ContactsContactIdExpensesRouteImport } from './routes/contacts/$contactId_/expenses'
import { Route as ContactsContactIdEmailsRouteImport } from './routes/contacts/$contactId_/emails'
import { Route as ContactsContactIdDonationsRouteImport } from './routes/contacts/$contactId_/donations'
import { Route as ContactsContactIdEditRouteImport } from './routes/contacts/$contactId.edit'
import { Route as EmailssentEmailIdRouteRouteImport } from './routes/emails/(sent)/$emailId/route'
import { Route as EmailsDraftsDraftIdIndexRouteImport } from './routes/emails/drafts/$draftId/index'
import { Route as EmailssentEmailIdIndexRouteImport } from './routes/emails/(sent)/$emailId/index'
import { Route as EmailsDraftsDraftIdEditRouteImport } from './routes/emails/drafts/$draftId/edit'
import { Route as EmailssentEmailIdStatTypeRouteImport } from './routes/emails/(sent)/$emailId/$statType'

const SettingsRouteImport = createFileRoute('/settings')()

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TestViewsRoute = TestViewsRouteImport.update({
  id: '/test-views',
  path: '/test-views',
  getParentRoute: () => rootRouteImport,
} as any)
const AddonsRoute = AddonsRouteImport.update({
  id: '/addons',
  path: '/addons',
  getParentRoute: () => rootRouteImport,
} as any)
const FilesRouteRoute = FilesRouteRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesRouteRoute = ExpensesRouteRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const DonationsRouteRoute = DonationsRouteRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRouteRoute = CampaignsRouteRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FilesIndexRoute = FilesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FilesRouteRoute,
} as any)
const ExpensesIndexRoute = ExpensesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExpensesRouteRoute,
} as any)
const DonationsIndexRoute = DonationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DonationsRouteRoute,
} as any)
const ContactsIndexRoute = ContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CampaignsRouteRoute,
} as any)
const SettingsLayoutRoute = SettingsLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => SettingsRoute,
} as any)
const DonationsCategoriesRoute = DonationsCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => DonationsRouteRoute,
} as any)
const ContactsTasksRoute = ContactsTasksRouteImport.update({
  id: '/contacts/tasks',
  path: '/contacts/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsTaskTypesRoute = ContactsTaskTypesRouteImport.update({
  id: '/contacts/task-types',
  path: '/contacts/task-types',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsFixAndMergeRoute = ContactsFixAndMergeRouteImport.update({
  id: '/contacts/fix-and-merge',
  path: '/contacts/fix-and-merge',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsContactIdRouteRoute = ContactsContactIdRouteRouteImport.update({
  id: '/contacts/$contactId_',
  path: '/contacts/$contactId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLayoutIndexRoute = SettingsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsLayoutRoute,
} as any)
const EmailsTemplatesIndexRoute = EmailsTemplatesIndexRouteImport.update({
  id: '/emails/templates/',
  path: '/emails/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsScheduledIndexRoute = EmailsScheduledIndexRouteImport.update({
  id: '/emails/scheduled/',
  path: '/emails/scheduled/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsDraftsIndexRoute = EmailsDraftsIndexRouteImport.update({
  id: '/emails/drafts/',
  path: '/emails/drafts/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsDesignsIndexRoute = EmailsDesignsIndexRouteImport.update({
  id: '/emails/designs/',
  path: '/emails/designs/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailssentIndexRoute = EmailssentIndexRouteImport.update({
  id: '/emails/(sent)/',
  path: '/emails/',
  getParentRoute: () => rootRouteImport,
} as any)
const DonationsDonationIdIndexRoute =
  DonationsDonationIdIndexRouteImport.update({
    id: '/$donationId/',
    path: '/$donationId/',
    getParentRoute: () => DonationsRouteRoute,
  } as any)
const ContactsGroupsIndexRoute = ContactsGroupsIndexRouteImport.update({
  id: '/contacts/groups/',
  path: '/contacts/groups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsContactIdIndexRoute = ContactsContactIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)
const SettingsLayoutEmailsRoute = SettingsLayoutEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => SettingsLayoutRoute,
} as any)
const SettingsLayoutBillingRoute = SettingsLayoutBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsLayoutRoute,
} as any)
const EmailsTemplatesTemplateIdRoute =
  EmailsTemplatesTemplateIdRouteImport.update({
    id: '/emails/templates/$templateId',
    path: '/emails/templates/$templateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmailsScheduledScheduledIdRoute =
  EmailsScheduledScheduledIdRouteImport.update({
    id: '/emails/scheduled/$scheduledId',
    path: '/emails/scheduled/$scheduledId',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmailsDesignsDesignIdRoute = EmailsDesignsDesignIdRouteImport.update({
  id: '/emails/designs/$designId',
  path: '/emails/designs/$designId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsGroupsGroupIdRoute = ContactsGroupsGroupIdRouteImport.update({
  id: '/contacts/groups/$groupId',
  path: '/contacts/groups/$groupId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsContactIdFilesRoute = ContactsContactIdFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)
const ContactsContactIdExpensesRoute =
  ContactsContactIdExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => ContactsContactIdRouteRoute,
  } as any)
const ContactsContactIdEmailsRoute = ContactsContactIdEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => ContactsContactIdRouteRoute,
} as any)
const ContactsContactIdDonationsRoute =
  ContactsContactIdDonationsRouteImport.update({
    id: '/donations',
    path: '/donations',
    getParentRoute: () => ContactsContactIdRouteRoute,
  } as any)
const ContactsContactIdEditRoute = ContactsContactIdEditRouteImport.update({
  id: '/contacts/$contactId/edit',
  path: '/contacts/$contactId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailssentEmailIdRouteRoute = EmailssentEmailIdRouteRouteImport.update({
  id: '/emails/(sent)/$emailId',
  path: '/emails/$emailId',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsDraftsDraftIdIndexRoute =
  EmailsDraftsDraftIdIndexRouteImport.update({
    id: '/emails/drafts/$draftId/',
    path: '/emails/drafts/$draftId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmailssentEmailIdIndexRoute = EmailssentEmailIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmailssentEmailIdRouteRoute,
} as any)
const EmailsDraftsDraftIdEditRoute = EmailsDraftsDraftIdEditRouteImport.update({
  id: '/emails/drafts/$draftId/edit',
  path: '/emails/drafts/$draftId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailssentEmailIdStatTypeRoute =
  EmailssentEmailIdStatTypeRouteImport.update({
    id: '/$statType',
    path: '/$statType',
    getParentRoute: () => EmailssentEmailIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/campaigns': typeof CampaignsRouteRouteWithChildren
  '/donations': typeof DonationsRouteRouteWithChildren
  '/expenses': typeof ExpensesRouteRouteWithChildren
  '/files': typeof FilesRouteRouteWithChildren
  '/addons': typeof AddonsRoute
  '/test-views': typeof TestViewsRoute
  '/contacts/$contactId': typeof ContactsContactIdRouteRouteWithChildren
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsLayoutRouteWithChildren
  '/campaigns/': typeof CampaignsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/donations/': typeof DonationsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/files/': typeof FilesIndexRoute
  '/emails/$emailId': typeof EmailssentEmailIdRouteRouteWithChildren
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/billing': typeof SettingsLayoutBillingRoute
  '/settings/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId/': typeof ContactsContactIdIndexRoute
  '/contacts/groups': typeof ContactsGroupsIndexRoute
  '/donations/$donationId': typeof DonationsDonationIdIndexRoute
  '/emails': typeof EmailssentIndexRoute
  '/emails/designs': typeof EmailsDesignsIndexRoute
  '/emails/drafts': typeof EmailsDraftsIndexRoute
  '/emails/scheduled': typeof EmailsScheduledIndexRoute
  '/emails/templates': typeof EmailsTemplatesIndexRoute
  '/settings/': typeof SettingsLayoutIndexRoute
  '/emails/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/$emailId/': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId': typeof EmailsDraftsDraftIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/addons': typeof AddonsRoute
  '/test-views': typeof TestViewsRoute
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsLayoutIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/donations': typeof DonationsIndexRoute
  '/expenses': typeof ExpensesIndexRoute
  '/files': typeof FilesIndexRoute
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/billing': typeof SettingsLayoutBillingRoute
  '/settings/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId': typeof ContactsContactIdIndexRoute
  '/contacts/groups': typeof ContactsGroupsIndexRoute
  '/donations/$donationId': typeof DonationsDonationIdIndexRoute
  '/emails': typeof EmailssentIndexRoute
  '/emails/designs': typeof EmailsDesignsIndexRoute
  '/emails/drafts': typeof EmailsDraftsIndexRoute
  '/emails/scheduled': typeof EmailsScheduledIndexRoute
  '/emails/templates': typeof EmailsTemplatesIndexRoute
  '/emails/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/$emailId': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId': typeof EmailsDraftsDraftIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/campaigns': typeof CampaignsRouteRouteWithChildren
  '/donations': typeof DonationsRouteRouteWithChildren
  '/expenses': typeof ExpensesRouteRouteWithChildren
  '/files': typeof FilesRouteRouteWithChildren
  '/addons': typeof AddonsRoute
  '/test-views': typeof TestViewsRoute
  '/contacts/$contactId_': typeof ContactsContactIdRouteRouteWithChildren
  '/contacts/fix-and-merge': typeof ContactsFixAndMergeRoute
  '/contacts/task-types': typeof ContactsTaskTypesRoute
  '/contacts/tasks': typeof ContactsTasksRoute
  '/donations/categories': typeof DonationsCategoriesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/settings/_layout': typeof SettingsLayoutRouteWithChildren
  '/campaigns/': typeof CampaignsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/donations/': typeof DonationsIndexRoute
  '/expenses/': typeof ExpensesIndexRoute
  '/files/': typeof FilesIndexRoute
  '/emails/(sent)/$emailId': typeof EmailssentEmailIdRouteRouteWithChildren
  '/contacts/$contactId/edit': typeof ContactsContactIdEditRoute
  '/contacts/$contactId_/donations': typeof ContactsContactIdDonationsRoute
  '/contacts/$contactId_/emails': typeof ContactsContactIdEmailsRoute
  '/contacts/$contactId_/expenses': typeof ContactsContactIdExpensesRoute
  '/contacts/$contactId_/files': typeof ContactsContactIdFilesRoute
  '/contacts/groups/$groupId': typeof ContactsGroupsGroupIdRoute
  '/emails/designs/$designId': typeof EmailsDesignsDesignIdRoute
  '/emails/scheduled/$scheduledId': typeof EmailsScheduledScheduledIdRoute
  '/emails/templates/$templateId': typeof EmailsTemplatesTemplateIdRoute
  '/settings/_layout/billing': typeof SettingsLayoutBillingRoute
  '/settings/_layout/emails': typeof SettingsLayoutEmailsRoute
  '/contacts/$contactId_/': typeof ContactsContactIdIndexRoute
  '/contacts/groups/': typeof ContactsGroupsIndexRoute
  '/donations/$donationId/': typeof DonationsDonationIdIndexRoute
  '/emails/(sent)/': typeof EmailssentIndexRoute
  '/emails/designs/': typeof EmailsDesignsIndexRoute
  '/emails/drafts/': typeof EmailsDraftsIndexRoute
  '/emails/scheduled/': typeof EmailsScheduledIndexRoute
  '/emails/templates/': typeof EmailsTemplatesIndexRoute
  '/settings/_layout/': typeof SettingsLayoutIndexRoute
  '/emails/(sent)/$emailId/$statType': typeof EmailssentEmailIdStatTypeRoute
  '/emails/drafts/$draftId/edit': typeof EmailsDraftsDraftIdEditRoute
  '/emails/(sent)/$emailId/': typeof EmailssentEmailIdIndexRoute
  '/emails/drafts/$draftId/': typeof EmailsDraftsDraftIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/campaigns'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/addons'
    | '/test-views'
    | '/contacts/$contactId'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/campaigns/'
    | '/contacts'
    | '/donations/'
    | '/expenses/'
    | '/files/'
    | '/emails/$emailId'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId/donations'
    | '/contacts/$contactId/emails'
    | '/contacts/$contactId/expenses'
    | '/contacts/$contactId/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/billing'
    | '/settings/emails'
    | '/contacts/$contactId/'
    | '/contacts/groups'
    | '/donations/$donationId'
    | '/emails'
    | '/emails/designs'
    | '/emails/drafts'
    | '/emails/scheduled'
    | '/emails/templates'
    | '/settings/'
    | '/emails/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/$emailId/'
    | '/emails/drafts/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/addons'
    | '/test-views'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/campaigns'
    | '/contacts'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId/donations'
    | '/contacts/$contactId/emails'
    | '/contacts/$contactId/expenses'
    | '/contacts/$contactId/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/billing'
    | '/settings/emails'
    | '/contacts/$contactId'
    | '/contacts/groups'
    | '/donations/$donationId'
    | '/emails'
    | '/emails/designs'
    | '/emails/drafts'
    | '/emails/scheduled'
    | '/emails/templates'
    | '/emails/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/$emailId'
    | '/emails/drafts/$draftId'
  id:
    | '__root__'
    | '/'
    | '/campaigns'
    | '/donations'
    | '/expenses'
    | '/files'
    | '/addons'
    | '/test-views'
    | '/contacts/$contactId_'
    | '/contacts/fix-and-merge'
    | '/contacts/task-types'
    | '/contacts/tasks'
    | '/donations/categories'
    | '/settings'
    | '/settings/_layout'
    | '/campaigns/'
    | '/contacts/'
    | '/donations/'
    | '/expenses/'
    | '/files/'
    | '/emails/(sent)/$emailId'
    | '/contacts/$contactId/edit'
    | '/contacts/$contactId_/donations'
    | '/contacts/$contactId_/emails'
    | '/contacts/$contactId_/expenses'
    | '/contacts/$contactId_/files'
    | '/contacts/groups/$groupId'
    | '/emails/designs/$designId'
    | '/emails/scheduled/$scheduledId'
    | '/emails/templates/$templateId'
    | '/settings/_layout/billing'
    | '/settings/_layout/emails'
    | '/contacts/$contactId_/'
    | '/contacts/groups/'
    | '/donations/$donationId/'
    | '/emails/(sent)/'
    | '/emails/designs/'
    | '/emails/drafts/'
    | '/emails/scheduled/'
    | '/emails/templates/'
    | '/settings/_layout/'
    | '/emails/(sent)/$emailId/$statType'
    | '/emails/drafts/$draftId/edit'
    | '/emails/(sent)/$emailId/'
    | '/emails/drafts/$draftId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CampaignsRouteRoute: typeof CampaignsRouteRouteWithChildren
  DonationsRouteRoute: typeof DonationsRouteRouteWithChildren
  ExpensesRouteRoute: typeof ExpensesRouteRouteWithChildren
  FilesRouteRoute: typeof FilesRouteRouteWithChildren
  AddonsRoute: typeof AddonsRoute
  TestViewsRoute: typeof TestViewsRoute
  ContactsContactIdRouteRoute: typeof ContactsContactIdRouteRouteWithChildren
  ContactsFixAndMergeRoute: typeof ContactsFixAndMergeRoute
  ContactsTaskTypesRoute: typeof ContactsTaskTypesRoute
  ContactsTasksRoute: typeof ContactsTasksRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ContactsIndexRoute: typeof ContactsIndexRoute
  EmailssentEmailIdRouteRoute: typeof EmailssentEmailIdRouteRouteWithChildren
  ContactsContactIdEditRoute: typeof ContactsContactIdEditRoute
  ContactsGroupsGroupIdRoute: typeof ContactsGroupsGroupIdRoute
  EmailsDesignsDesignIdRoute: typeof EmailsDesignsDesignIdRoute
  EmailsScheduledScheduledIdRoute: typeof EmailsScheduledScheduledIdRoute
  EmailsTemplatesTemplateIdRoute: typeof EmailsTemplatesTemplateIdRoute
  ContactsGroupsIndexRoute: typeof ContactsGroupsIndexRoute
  EmailssentIndexRoute: typeof EmailssentIndexRoute
  EmailsDesignsIndexRoute: typeof EmailsDesignsIndexRoute
  EmailsDraftsIndexRoute: typeof EmailsDraftsIndexRoute
  EmailsScheduledIndexRoute: typeof EmailsScheduledIndexRoute
  EmailsTemplatesIndexRoute: typeof EmailsTemplatesIndexRoute
  EmailsDraftsDraftIdEditRoute: typeof EmailsDraftsDraftIdEditRoute
  EmailsDraftsDraftIdIndexRoute: typeof EmailsDraftsDraftIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-views': {
      id: '/test-views'
      path: '/test-views'
      fullPath: '/test-views'
      preLoaderRoute: typeof TestViewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/addons': {
      id: '/addons'
      path: '/addons'
      fullPath: '/addons'
      preLoaderRoute: typeof AddonsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/files': {
      id: '/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof FilesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses': {
      id: '/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ExpensesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donations': {
      id: '/donations'
      path: '/donations'
      fullPath: '/donations'
      preLoaderRoute: typeof DonationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/files/': {
      id: '/files/'
      path: '/'
      fullPath: '/files/'
      preLoaderRoute: typeof FilesIndexRouteImport
      parentRoute: typeof FilesRouteRoute
    }
    '/expenses/': {
      id: '/expenses/'
      path: '/'
      fullPath: '/expenses/'
      preLoaderRoute: typeof ExpensesIndexRouteImport
      parentRoute: typeof ExpensesRouteRoute
    }
    '/donations/': {
      id: '/donations/'
      path: '/'
      fullPath: '/donations/'
      preLoaderRoute: typeof DonationsIndexRouteImport
      parentRoute: typeof DonationsRouteRoute
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof CampaignsRouteRoute
    }
    '/settings/_layout': {
      id: '/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLayoutRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/donations/categories': {
      id: '/donations/categories'
      path: '/categories'
      fullPath: '/donations/categories'
      preLoaderRoute: typeof DonationsCategoriesRouteImport
      parentRoute: typeof DonationsRouteRoute
    }
    '/contacts/tasks': {
      id: '/contacts/tasks'
      path: '/contacts/tasks'
      fullPath: '/contacts/tasks'
      preLoaderRoute: typeof ContactsTasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/task-types': {
      id: '/contacts/task-types'
      path: '/contacts/task-types'
      fullPath: '/contacts/task-types'
      preLoaderRoute: typeof ContactsTaskTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/fix-and-merge': {
      id: '/contacts/fix-and-merge'
      path: '/contacts/fix-and-merge'
      fullPath: '/contacts/fix-and-merge'
      preLoaderRoute: typeof ContactsFixAndMergeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$contactId_': {
      id: '/contacts/$contactId_'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof ContactsContactIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/_layout/': {
      id: '/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsLayoutIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/emails/templates/': {
      id: '/emails/templates/'
      path: '/emails/templates'
      fullPath: '/emails/templates'
      preLoaderRoute: typeof EmailsTemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/scheduled/': {
      id: '/emails/scheduled/'
      path: '/emails/scheduled'
      fullPath: '/emails/scheduled'
      preLoaderRoute: typeof EmailsScheduledIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/drafts/': {
      id: '/emails/drafts/'
      path: '/emails/drafts'
      fullPath: '/emails/drafts'
      preLoaderRoute: typeof EmailsDraftsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/designs/': {
      id: '/emails/designs/'
      path: '/emails/designs'
      fullPath: '/emails/designs'
      preLoaderRoute: typeof EmailsDesignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/(sent)/': {
      id: '/emails/(sent)/'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailssentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donations/$donationId/': {
      id: '/donations/$donationId/'
      path: '/$donationId'
      fullPath: '/donations/$donationId'
      preLoaderRoute: typeof DonationsDonationIdIndexRouteImport
      parentRoute: typeof DonationsRouteRoute
    }
    '/contacts/groups/': {
      id: '/contacts/groups/'
      path: '/contacts/groups'
      fullPath: '/contacts/groups'
      preLoaderRoute: typeof ContactsGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$contactId_/': {
      id: '/contacts/$contactId_/'
      path: '/'
      fullPath: '/contacts/$contactId/'
      preLoaderRoute: typeof ContactsContactIdIndexRouteImport
      parentRoute: typeof ContactsContactIdRouteRoute
    }
    '/settings/_layout/emails': {
      id: '/settings/_layout/emails'
      path: '/emails'
      fullPath: '/settings/emails'
      preLoaderRoute: typeof SettingsLayoutEmailsRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/settings/_layout/billing': {
      id: '/settings/_layout/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsLayoutBillingRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/emails/templates/$templateId': {
      id: '/emails/templates/$templateId'
      path: '/emails/templates/$templateId'
      fullPath: '/emails/templates/$templateId'
      preLoaderRoute: typeof EmailsTemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/scheduled/$scheduledId': {
      id: '/emails/scheduled/$scheduledId'
      path: '/emails/scheduled/$scheduledId'
      fullPath: '/emails/scheduled/$scheduledId'
      preLoaderRoute: typeof EmailsScheduledScheduledIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/designs/$designId': {
      id: '/emails/designs/$designId'
      path: '/emails/designs/$designId'
      fullPath: '/emails/designs/$designId'
      preLoaderRoute: typeof EmailsDesignsDesignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/groups/$groupId': {
      id: '/contacts/groups/$groupId'
      path: '/contacts/groups/$groupId'
      fullPath: '/contacts/groups/$groupId'
      preLoaderRoute: typeof ContactsGroupsGroupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/$contactId_/files': {
      id: '/contacts/$contactId_/files'
      path: '/files'
      fullPath: '/contacts/$contactId/files'
      preLoaderRoute: typeof ContactsContactIdFilesRouteImport
      parentRoute: typeof ContactsContactIdRouteRoute
    }
    '/contacts/$contactId_/expenses': {
      id: '/contacts/$contactId_/expenses'
      path: '/expenses'
      fullPath: '/contacts/$contactId/expenses'
      preLoaderRoute: typeof ContactsContactIdExpensesRouteImport
      parentRoute: typeof ContactsContactIdRouteRoute
    }
    '/contacts/$contactId_/emails': {
      id: '/contacts/$contactId_/emails'
      path: '/emails'
      fullPath: '/contacts/$contactId/emails'
      preLoaderRoute: typeof ContactsContactIdEmailsRouteImport
      parentRoute: typeof ContactsContactIdRouteRoute
    }
    '/contacts/$contactId_/donations': {
      id: '/contacts/$contactId_/donations'
      path: '/donations'
      fullPath: '/contacts/$contactId/donations'
      preLoaderRoute: typeof ContactsContactIdDonationsRouteImport
      parentRoute: typeof ContactsContactIdRouteRoute
    }
    '/contacts/$contactId/edit': {
      id: '/contacts/$contactId/edit'
      path: '/contacts/$contactId/edit'
      fullPath: '/contacts/$contactId/edit'
      preLoaderRoute: typeof ContactsContactIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/(sent)/$emailId': {
      id: '/emails/(sent)/$emailId'
      path: '/emails/$emailId'
      fullPath: '/emails/$emailId'
      preLoaderRoute: typeof EmailssentEmailIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/drafts/$draftId/': {
      id: '/emails/drafts/$draftId/'
      path: '/emails/drafts/$draftId'
      fullPath: '/emails/drafts/$draftId'
      preLoaderRoute: typeof EmailsDraftsDraftIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/(sent)/$emailId/': {
      id: '/emails/(sent)/$emailId/'
      path: '/'
      fullPath: '/emails/$emailId/'
      preLoaderRoute: typeof EmailssentEmailIdIndexRouteImport
      parentRoute: typeof EmailssentEmailIdRouteRoute
    }
    '/emails/drafts/$draftId/edit': {
      id: '/emails/drafts/$draftId/edit'
      path: '/emails/drafts/$draftId/edit'
      fullPath: '/emails/drafts/$draftId/edit'
      preLoaderRoute: typeof EmailsDraftsDraftIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails/(sent)/$emailId/$statType': {
      id: '/emails/(sent)/$emailId/$statType'
      path: '/$statType'
      fullPath: '/emails/$emailId/$statType'
      preLoaderRoute: typeof EmailssentEmailIdStatTypeRouteImport
      parentRoute: typeof EmailssentEmailIdRouteRoute
    }
  }
}

interface CampaignsRouteRouteChildren {
  CampaignsIndexRoute: typeof CampaignsIndexRoute
}

const CampaignsRouteRouteChildren: CampaignsRouteRouteChildren = {
  CampaignsIndexRoute: CampaignsIndexRoute,
}

const CampaignsRouteRouteWithChildren = CampaignsRouteRoute._addFileChildren(
  CampaignsRouteRouteChildren,
)

interface DonationsRouteRouteChildren {
  DonationsCategoriesRoute: typeof DonationsCategoriesRoute
  DonationsIndexRoute: typeof DonationsIndexRoute
  DonationsDonationIdIndexRoute: typeof DonationsDonationIdIndexRoute
}

const DonationsRouteRouteChildren: DonationsRouteRouteChildren = {
  DonationsCategoriesRoute: DonationsCategoriesRoute,
  DonationsIndexRoute: DonationsIndexRoute,
  DonationsDonationIdIndexRoute: DonationsDonationIdIndexRoute,
}

const DonationsRouteRouteWithChildren = DonationsRouteRoute._addFileChildren(
  DonationsRouteRouteChildren,
)

interface ExpensesRouteRouteChildren {
  ExpensesIndexRoute: typeof ExpensesIndexRoute
}

const ExpensesRouteRouteChildren: ExpensesRouteRouteChildren = {
  ExpensesIndexRoute: ExpensesIndexRoute,
}

const ExpensesRouteRouteWithChildren = ExpensesRouteRoute._addFileChildren(
  ExpensesRouteRouteChildren,
)

interface FilesRouteRouteChildren {
  FilesIndexRoute: typeof FilesIndexRoute
}

const FilesRouteRouteChildren: FilesRouteRouteChildren = {
  FilesIndexRoute: FilesIndexRoute,
}

const FilesRouteRouteWithChildren = FilesRouteRoute._addFileChildren(
  FilesRouteRouteChildren,
)

interface ContactsContactIdRouteRouteChildren {
  ContactsContactIdDonationsRoute: typeof ContactsContactIdDonationsRoute
  ContactsContactIdEmailsRoute: typeof ContactsContactIdEmailsRoute
  ContactsContactIdExpensesRoute: typeof ContactsContactIdExpensesRoute
  ContactsContactIdFilesRoute: typeof ContactsContactIdFilesRoute
  ContactsContactIdIndexRoute: typeof ContactsContactIdIndexRoute
}

const ContactsContactIdRouteRouteChildren: ContactsContactIdRouteRouteChildren =
  {
    ContactsContactIdDonationsRoute: ContactsContactIdDonationsRoute,
    ContactsContactIdEmailsRoute: ContactsContactIdEmailsRoute,
    ContactsContactIdExpensesRoute: ContactsContactIdExpensesRoute,
    ContactsContactIdFilesRoute: ContactsContactIdFilesRoute,
    ContactsContactIdIndexRoute: ContactsContactIdIndexRoute,
  }

const ContactsContactIdRouteRouteWithChildren =
  ContactsContactIdRouteRoute._addFileChildren(
    ContactsContactIdRouteRouteChildren,
  )

interface SettingsLayoutRouteChildren {
  SettingsLayoutBillingRoute: typeof SettingsLayoutBillingRoute
  SettingsLayoutEmailsRoute: typeof SettingsLayoutEmailsRoute
  SettingsLayoutIndexRoute: typeof SettingsLayoutIndexRoute
}

const SettingsLayoutRouteChildren: SettingsLayoutRouteChildren = {
  SettingsLayoutBillingRoute: SettingsLayoutBillingRoute,
  SettingsLayoutEmailsRoute: SettingsLayoutEmailsRoute,
  SettingsLayoutIndexRoute: SettingsLayoutIndexRoute,
}

const SettingsLayoutRouteWithChildren = SettingsLayoutRoute._addFileChildren(
  SettingsLayoutRouteChildren,
)

interface SettingsRouteChildren {
  SettingsLayoutRoute: typeof SettingsLayoutRouteWithChildren
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsLayoutRoute: SettingsLayoutRouteWithChildren,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface EmailssentEmailIdRouteRouteChildren {
  EmailssentEmailIdStatTypeRoute: typeof EmailssentEmailIdStatTypeRoute
  EmailssentEmailIdIndexRoute: typeof EmailssentEmailIdIndexRoute
}

const EmailssentEmailIdRouteRouteChildren: EmailssentEmailIdRouteRouteChildren =
  {
    EmailssentEmailIdStatTypeRoute: EmailssentEmailIdStatTypeRoute,
    EmailssentEmailIdIndexRoute: EmailssentEmailIdIndexRoute,
  }

const EmailssentEmailIdRouteRouteWithChildren =
  EmailssentEmailIdRouteRoute._addFileChildren(
    EmailssentEmailIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CampaignsRouteRoute: CampaignsRouteRouteWithChildren,
  DonationsRouteRoute: DonationsRouteRouteWithChildren,
  ExpensesRouteRoute: ExpensesRouteRouteWithChildren,
  FilesRouteRoute: FilesRouteRouteWithChildren,
  AddonsRoute: AddonsRoute,
  TestViewsRoute: TestViewsRoute,
  ContactsContactIdRouteRoute: ContactsContactIdRouteRouteWithChildren,
  ContactsFixAndMergeRoute: ContactsFixAndMergeRoute,
  ContactsTaskTypesRoute: ContactsTaskTypesRoute,
  ContactsTasksRoute: ContactsTasksRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ContactsIndexRoute: ContactsIndexRoute,
  EmailssentEmailIdRouteRoute: EmailssentEmailIdRouteRouteWithChildren,
  ContactsContactIdEditRoute: ContactsContactIdEditRoute,
  ContactsGroupsGroupIdRoute: ContactsGroupsGroupIdRoute,
  EmailsDesignsDesignIdRoute: EmailsDesignsDesignIdRoute,
  EmailsScheduledScheduledIdRoute: EmailsScheduledScheduledIdRoute,
  EmailsTemplatesTemplateIdRoute: EmailsTemplatesTemplateIdRoute,
  ContactsGroupsIndexRoute: ContactsGroupsIndexRoute,
  EmailssentIndexRoute: EmailssentIndexRoute,
  EmailsDesignsIndexRoute: EmailsDesignsIndexRoute,
  EmailsDraftsIndexRoute: EmailsDraftsIndexRoute,
  EmailsScheduledIndexRoute: EmailsScheduledIndexRoute,
  EmailsTemplatesIndexRoute: EmailsTemplatesIndexRoute,
  EmailsDraftsDraftIdEditRoute: EmailsDraftsDraftIdEditRoute,
  EmailsDraftsDraftIdIndexRoute: EmailsDraftsDraftIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
